import React from 'react'
import { Match } from 'sutra/components/Autocomplete/autocomplete-styles'
import { splitByMatch } from 'sutra/components/Autocomplete/split-by-match'

export const HighlightedLabel = ({
  label,
  query,
}: {
  label: string
  query: string
}): React.ReactElement => {
  const { before, match, after } = splitByMatch(label, query)

  return (
    <span>
      {before}
      {match && <Match>{match}</Match>}
      {after}
    </span>
  )
}
